module.exports = __webpack_public_path__ + "img/eclipse.2134a9c0.png";